<template>
  <b-card
    class="search-result-item margin-bottom-20"
    tabindex="0"
    @keypress.enter="openDocument(result)"
    @click="openDocument(result)"
  >
    <div class="search-result-icon-col">
      <template v-if="isChild">
        <img class="menu-icon" :src="'static/icons/icon-Aula_paper_child.svg'" />
      </template>
      <i v-else class="icon-Aula_paper" />
    </div>
    <div class="search-result-text-col">
      <div class="card-header-text">
        <keyword-highlight :queries="searchString">
          {{ result.title }}
        </keyword-highlight>
      </div>
      <div class="card-text">
        {{ $getText('SEARCH_CREATED_LABEL') }}: {{ formattedCreatedDate }}<br />
        {{ result.institutionName }}
        <template v-if="result.docType != docTypes.IMPORTANT_FILE">
          {{ $getText('SEARCH_CREATOR_BY_LABEL') }}:
          <keyword-highlight :queries="searchString"> {{ result.creatorName }} </keyword-highlight><br />
          <template v-if="isSteppedUp">
            {{ $getText('SEARCH_CATEGORY_LABEL') }}:
            <keyword-highlight :queries="searchString"> {{ result.category }} </keyword-highlight><br />
            {{ $getText('SEARCH_ASSOCIATION_LABEL') }}:
            <keyword-highlight :queries="searchString"> {{ associations }} </keyword-highlight><br />
          </template>
        </template>
      </div>
    </div>
  </b-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import KeywordHighlight from 'vue-text-highlight';
import { types } from '../../store/types/types';
import moment from 'moment-timezone';
import { docTypes } from '../../../shared/enums/docTypes';
import { browserUtil } from '../../../shared/utils/browserUtil';
import { DateTimeUtil } from '../../../shared/utils/dateTimeUtil';

export default {
  props: {
    result: { type: Object, default: () => {} },
    searchString: { type: String, default: null },
    isChild: { type: Boolean, default: false },
  },
  data: function () {
    return {
      moment: moment,
      docTypes: docTypes,
    };
  },
  computed: {
    ...mapGetters({
      isSteppedUp: types.GET_GLOBAL_STEPPED_UP,
    }),
    formattedCreatedDate() {
      return DateTimeUtil.shortDate(this.result.created, true);
    },
    associations() {
      let associations = '';
      if (this.result.childAssociations?.length > 0) {
        associations = this.result.childAssociations.map(child => child.firstName + ' ' + child.lastName).join(', ');
      }
      if (this.result.groupAssociations?.length > 0) {
        if (associations !== '') {
          associations += ', ';
        }
        associations += this.result.groupAssociations.map(group => group.name).join(', ');
      }
      return associations;
    },
  },
  methods: {
    ...mapMutations({
      setStepUpNotification: types.MUTATE_SET_NOTIFICATION_STEP_UP,
    }),
    getDocumentUrl(document) {
      let url;
      if (document.isInternal) {
        url = browserUtil.getSiteUrl('portal') + '/#/dokumenter/sikre/internal/' + document.id;
      } else {
        url = browserUtil.getSiteUrl('portal') + '/#/dokumenter/sikre/external/' + document.id;
      }
      return url;
    },
    openDocument(document) {
      if (document.docType == docTypes.IMPORTANT_FILE) {
        window.location.href = document.url;
      } else {
        if (this.isSteppedUp) {
          if (document.docType == docTypes.INTERNAL_SECURE_FILE) {
            this.$router.push('dokumenter/sikre/internal/' + document.id);
          } else if (document.docType == docTypes.EXTERNAL_SECURE_FILE) {
            this.$router.push('dokumenter/sikre/external/' + document.id);
          }
        } else {
          let url = '';
          if (document.docType == docTypes.INTERNAL_SECURE_FILE) {
            url = browserUtil.getSiteUrl('portal') + '/#/dokumenter/sikre/internal/' + document.id;
          } else if (document.docType == docTypes.EXTERNAL_SECURE_FILE) {
            url = browserUtil.getSiteUrl('portal') + '/#/dokumenter/sikre/external/' + document.id;
          }
          this.setStepUpNotification({
            showStepUpNotification: true,
            redirectedUrl: url,
          });
        }
      }
    },
  },
  components: {
    KeywordHighlight,
  },
};
</script>

<style scoped lang="scss">
@use '../../../shared/assets/scss/core/variables' as *;
@use '../../../shared/assets/scss/core/breakpoints' as *;

.card-text {
  text-transform: capitalize;
}
</style>
